import { StyleSheet } from "react-native";
import { MaskedTextInput } from "react-native-mask-text";
import { TextInput, useTheme } from "react-native-paper";
import { useTailwind } from "tailwind-rn";
import { cellphoneMask } from "utils";

import Copy from "../../../copy";
import { CountryCode } from "../../../types";

type Props = {
  countryCode: CountryCode;
  phone: string;
  setPhone: (phone: string) => void;
};

export default function PhoneInput({ countryCode, phone, setPhone }: Props) {
  const { colors } = useTheme();
  const tailwind = useTailwind();
  return (
    <TextInput
      value={phone}
      label={Copy.LOGIN_CELULAR_SCREEN_DISPLAY_HEADER_TEXT}
      placeholder={Copy.LOGIN_CELULAR_SCREEN_DISPLAY_PLACEHOLDER}
      mode="outlined"
      onChangeText={setPhone}
      render={({ style, ...props }) => {
        const mask = cellphoneMask(countryCode);
        return (
          <MaskedTextInput
            {...props}
            onChangeText={(_maskedText, rawText) => setPhone(rawText)}
            style={StyleSheet.flatten(style)}
            mask={mask}
            maxLength={mask.length}
          />
        );
      }}
      keyboardType="number-pad"
      left={
        <TextInput.Affix
          text={`+${countryCode}`}
          textStyle={[
            { color: colors.onSurface },
            tailwind("font-medium pt-0.5"),
          ]}
        />
      }
      right={
        phone && (
          <TextInput.Icon
            icon="close-circle-outline"
            onPress={() => setPhone("")}
          />
        )
      }
      style={tailwind("flex-1")}
      autoFocus
      dense
    />
  );
}
